import React from "react";
//import RenderSubscribedValues from "../../../rxjs/RenderSubscribedValues";
//import BalancesObservable from "../../../rxjs/observables/incomingmessage/BalancesObservable";
import AgAccountBalances from "./AgAccountBalances";
import {observer} from "mobx-react-lite";
import {useWebsocketStore} from "../../../stores/websocketStore/websocketProvider";
/*

export class DisplayAccountBalances1 extends React.Component {
    constructor(props) {
        super(props);
        this.observable = BalancesObservable;
        this.state = {storedValues: {}};
    }

    componentDidMount() {
        this.subscription = this.observable.subscribe((msg) => {
            //console.log("piped from observable: " + JSON.stringify(value));
            for (let acctId in msg) {
                let acct = msg[acctId];
                let storedValues = this.state.storedValues;
                storedValues[acctId] = acct;
                this.setState({storedValues: storedValues});
            }
        });
    }

    componentWillUnmount() {
        this.subscription.unsubscribe();
    }

    render() {
        const Component = this.component;
        return <AgAccountBalances values={this.state.storedValues}/>;
    }
}
*/

const DisplayAccountBalances = observer(({}) => {
    const {accountBalanceStore} = useWebsocketStore();
    return <AgAccountBalances values={accountBalanceStore.balances}/>
});

export default DisplayAccountBalances
